import React from "react";
import { Spinner } from "reactstrap";
import PropTypes from "prop-types";

const Loading = ({ isLoading, children }) => {
	return (
		<>
			{isLoading && (
				<div style={overlayStyle}>
					<Spinner style={spinnerStyle} color="primary" />
				</div>
			)}
			{children}
		</>
	);
};

const overlayStyle = {
	position: "fixed",
	top: 0,
	left: 0,
	width: "100%",
	height: "100%",
	backgroundColor: "rgba(128, 128, 128, 0.5)",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	zIndex: 9999,
};

const spinnerStyle = {
	width: "3rem",
	height: "3rem",
};

Loading.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	children: PropTypes.node,
};

export default Loading;
